import axios from 'axios';

const state = {

    /*datos usuario*/
    admin_datos:[],
    token: localStorage.getItem('token_auth') || '',
    isLoggedIn: false,
    /*misc*/
    admin_cargando:0,
    admin_iniciado:false,
    propertyManagerPendingPaymentsCount: null,
    propertyManagerPendingPaymentsLoaded: false,
    propertyManagerPendingPaymentsLoading: false,
    propertyManagerPendingPaymentsLastRequest: null,
    propertyManagerPendingBudgetsCount: null,
    propertyManagerPendingBudgetsLoaded: false,
    propertyManagerPendingBudgetsLoading: false,
    propertyManagerPendingBudgetsLastRequest: null,


};

const getters = {
    token: state => state.token,
    admin_datos: state => state.admin_datos,
    isLoggedIn: state => state.isLoggedIn,
    admin_iniciado: state => state.admin_iniciado,
    propertyManagerPendingPaymentsCount: state => state.propertyManagerPendingPaymentsCount,
    propertyManagerPendingPaymentsLoaded: state => state.propertyManagerPendingPaymentsLoaded,
    propertyManagerPendingBudgetsCount: state => state.propertyManagerPendingBudgetsCount,
    propertyManagerPendingBudgetsLoaded: state => state.propertyManagerPendingBudgetsLoaded,
};

const actions = {
    getpro(context, payload){
        return new Promise((resolve, reject) => {
            context.commit('startLoading')
            axios({url:window.hostname+'api/admin/getadminbytoken', method: 'GET' })
            .then(resp => {
                const user = resp.data.user
                const data ={'token_auth': localStorage.token_auth, 'user': user}
                context.commit('auth_success', data)
                context.commit('stopLoading')
                resolve(resp)
            })
            .catch(err => {
                console.log(err.response)
                context.commit('logout')
                context.commit('stopLoading')
                localStorage.removeItem('token_auth')
                reject(err)
            })
        })
    },
    logoutpro(context){
        localStorage.removeItem('token_auth')
        context.commit('logout')
    },
    loginpro(context, user) {
        return new Promise((resolve, reject) => {
          context.commit('startLoading');
          axios({
            url: window.hostname + 'api/admin/login',
            data: user,
            method: 'POST',
          })
            .then((resp) => {
              const token = resp.data.token;
              const userData = resp.data.user;
              const data = { token_auth: token, user: userData };
              localStorage.setItem('token_auth', token);
              axios.defaults.headers.common['Authorization'] = token;
              context.commit('auth_success', data);
              context.commit('stopLoading');
              resolve(resp);
            })
            .catch((err) => {
              context.commit('stopLoading');
              context.commit('logout');
              localStorage.removeItem('token_auth');
              reject(err);
            });
        });
      },
      loginPropertyManager(context, user) {
        return new Promise((resolve, reject) => {
          context.commit('startLoading');
          axios({
            url: window.hostname + 'api/property_manager/login',
            data: user,
            method: 'POST',
          })
            .then((resp) => {
              const token = resp.data.token;
              const userData = resp.data.user;
              const data = { token_auth: token, user: userData };
              localStorage.setItem('token_auth', token);
              axios.defaults.headers.common['Authorization'] = token;
              context.commit('auth_success', data);
              context.commit('stopLoading');
              resolve(resp);
            })
            .catch((err) => {
              context.commit('stopLoading');
              context.commit('logout');
              localStorage.removeItem('token_auth');
              reject(err);
            });
        });
      },
      loginLeadPartner(context, user) {
        return new Promise((resolve, reject) => {
          context.commit('startLoading');
          axios({
            url: window.hostname + 'api/lead_partner/login',
            data: user,
            method: 'POST',
          })
            .then((resp) => {
              const token = resp.data.token;
              const userData = resp.data.user;
              const data = { token_auth: token, user: userData };
              localStorage.setItem('token_auth', token);
              axios.defaults.headers.common['Authorization'] = token;
              context.commit('auth_success', data);
              context.commit('stopLoading');
              resolve(resp);
            })
            .catch((err) => {
              context.commit('stopLoading');
              context.commit('logout');
              localStorage.removeItem('token_auth');
              reject(err);
            });
        });
      },
      fetchPropertyManagerPendingPaymentsCount({ state, commit }, { force = false } = {}) {
        if (state.propertyManagerPendingPaymentsLoading) {
          return state.propertyManagerPendingPaymentsLastRequest || Promise.resolve(state.propertyManagerPendingPaymentsCount);
        }

        if (!force && state.propertyManagerPendingPaymentsLoaded) {
          return Promise.resolve(state.propertyManagerPendingPaymentsCount);
        }

        commit('setPropertyManagerPendingPaymentsLoading', true);

        const request = axios
          .get(`${window.hostname}api/property_manager/deudas_items/count`)
          .then((response) => {
            const rawCount = response && response.data ? response.data.count : null;
            const parsedCount = Number(rawCount);
            const normalized = Number.isFinite(parsedCount) && parsedCount >= 0 ? parsedCount : 0;
            commit('setPropertyManagerPendingPaymentsCount', normalized);
            return normalized;
          })
          .catch((error) => {
            console.error('Error fetching pending payments count:', error);
            throw error;
          })
          .finally(() => {
            commit('setPropertyManagerPendingPaymentsLoading', false);
            commit('setPropertyManagerPendingPaymentsLastRequest', null);
          });

        commit('setPropertyManagerPendingPaymentsLastRequest', request);

        return request;
      },
      updatePropertyManagerPendingPaymentsFromOrders({ commit }, ordenes = []) {
        const safeList = Array.isArray(ordenes) ? ordenes : [];
        const pendingCount = safeList.reduce((acc, orden) => {
          const saldoPendiente = Number(orden && orden.saldo_pendiente);
          const totalRevision = Number(orden && orden.total_en_revision);
          if ((Number.isFinite(saldoPendiente) && saldoPendiente > 0) || (Number.isFinite(totalRevision) && totalRevision > 0)) {
            return acc + 1;
          }
          return acc;
        }, 0);

        commit('setPropertyManagerPendingPaymentsCount', pendingCount);
        return pendingCount;
      },
      resetPropertyManagerPendingPaymentsState({ commit }) {
        commit('resetPropertyManagerPendingPaymentsState');
      },
      fetchPropertyManagerPendingBudgetsCount({ state, commit }, { force = false } = {}) {
        if (state.propertyManagerPendingBudgetsLoading) {
          return state.propertyManagerPendingBudgetsLastRequest || Promise.resolve(state.propertyManagerPendingBudgetsCount);
        }

        if (!force && state.propertyManagerPendingBudgetsLoaded) {
          return Promise.resolve(state.propertyManagerPendingBudgetsCount);
        }

        commit('setPropertyManagerPendingBudgetsLoading', true);

        const request = axios
          .get(`${window.hostname}api/property_manager/presupuestos_pendientes/count`)
          .then((response) => {
            const rawCount = response && response.data ? response.data.count : null;
            const parsedCount = Number(rawCount);
            const normalized = Number.isFinite(parsedCount) && parsedCount >= 0 ? parsedCount : 0;
            commit('setPropertyManagerPendingBudgetsCount', normalized);
            return normalized;
          })
          .catch((error) => {
            console.error('Error fetching pending budgets count:', error);
            throw error;
          })
          .finally(() => {
            commit('setPropertyManagerPendingBudgetsLoading', false);
            commit('setPropertyManagerPendingBudgetsLastRequest', null);
          });

        commit('setPropertyManagerPendingBudgetsLastRequest', request);

        return request;
      },
      updatePropertyManagerPendingBudgetsFromList({ commit }, presupuestos = []) {
        const safeList = Array.isArray(presupuestos) ? presupuestos : [];
        const count = safeList.length;
        commit('setPropertyManagerPendingBudgetsCount', count);
        return count;
      },
      resetPropertyManagerPendingBudgetsState({ commit }) {
        commit('resetPropertyManagerPendingBudgetsState');
      },

};

const mutations = {
    auth_success(state, data){
        state.admin_datos = data.user
        state.token = data.token_auth
        state.isLoggedIn = true
        state.propertyManagerPendingPaymentsCount = null
        state.propertyManagerPendingPaymentsLoaded = false
        state.propertyManagerPendingPaymentsLoading = false
        state.propertyManagerPendingPaymentsLastRequest = null
        state.propertyManagerPendingBudgetsCount = null
        state.propertyManagerPendingBudgetsLoaded = false
        state.propertyManagerPendingBudgetsLoading = false
        state.propertyManagerPendingBudgetsLastRequest = null
      },
    logout(state){
        state.admin_datos = []
        state.isLoggedIn = false
        state.token = ''
        state.propertyManagerPendingPaymentsCount = null
        state.propertyManagerPendingPaymentsLoaded = false
        state.propertyManagerPendingPaymentsLoading = false
        state.propertyManagerPendingPaymentsLastRequest = null
        state.propertyManagerPendingBudgetsCount = null
        state.propertyManagerPendingBudgetsLoaded = false
        state.propertyManagerPendingBudgetsLoading = false
        state.propertyManagerPendingBudgetsLastRequest = null
      },
      startLoading: (state) => {state.cargando = 1},
      stopLoading: (state) => {state.cargando = 0},
      setPropertyManagerPendingPaymentsLoading(state, isLoading) {
        state.propertyManagerPendingPaymentsLoading = isLoading;
      },
      setPropertyManagerPendingPaymentsCount(state, count) {
        state.propertyManagerPendingPaymentsCount = count;
        state.propertyManagerPendingPaymentsLoaded = true;
      },
      setPropertyManagerPendingPaymentsLastRequest(state, request) {
        state.propertyManagerPendingPaymentsLastRequest = request;
      },
      resetPropertyManagerPendingPaymentsState(state) {
        state.propertyManagerPendingPaymentsCount = null;
        state.propertyManagerPendingPaymentsLoaded = false;
        state.propertyManagerPendingPaymentsLoading = false;
        state.propertyManagerPendingPaymentsLastRequest = null;
      },
      setPropertyManagerPendingBudgetsLoading(state, isLoading) {
        state.propertyManagerPendingBudgetsLoading = isLoading;
      },
      setPropertyManagerPendingBudgetsCount(state, count) {
        state.propertyManagerPendingBudgetsCount = count;
        state.propertyManagerPendingBudgetsLoaded = true;
      },
      setPropertyManagerPendingBudgetsLastRequest(state, request) {
        state.propertyManagerPendingBudgetsLastRequest = request;
      },
      resetPropertyManagerPendingBudgetsState(state) {
        state.propertyManagerPendingBudgetsCount = null;
        state.propertyManagerPendingBudgetsLoaded = false;
        state.propertyManagerPendingBudgetsLoading = false;
        state.propertyManagerPendingBudgetsLastRequest = null;
      },

};

export default{
    state,
    getters,
    actions,
    mutations,
};
